/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseServiceUrl } from '../base-service-url';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { getCustomerAvatar } from '../fn/avatar/get-customer-avatar';
import { GetCustomerAvatar$Params } from '../fn/avatar/get-customer-avatar';
import { getCustomerFeedMillAvatar } from '../fn/avatar/get-customer-feed-mill-avatar';
import { GetCustomerFeedMillAvatar$Params } from '../fn/avatar/get-customer-feed-mill-avatar';
import { getCustomerHatcheryAvatar } from '../fn/avatar/get-customer-hatchery-avatar';
import { GetCustomerHatcheryAvatar$Params } from '../fn/avatar/get-customer-hatchery-avatar';
import { getUserAvatar } from '../fn/avatar/get-user-avatar';
import { GetUserAvatar$Params } from '../fn/avatar/get-user-avatar';
import { ResultStringDto } from '../models/result-string-dto';
import { updateCustomerAvatar } from '../fn/avatar/update-customer-avatar';
import { UpdateCustomerAvatar$Params } from '../fn/avatar/update-customer-avatar';
import { updateCustomerFeedMillAvatar } from '../fn/avatar/update-customer-feed-mill-avatar';
import { UpdateCustomerFeedMillAvatar$Params } from '../fn/avatar/update-customer-feed-mill-avatar';
import { updateCustomerHatcheryAvatar } from '../fn/avatar/update-customer-hatchery-avatar';
import { UpdateCustomerHatcheryAvatar$Params } from '../fn/avatar/update-customer-hatchery-avatar';
import { updateUserAvatar } from '../fn/avatar/update-user-avatar';
import { UpdateUserAvatar$Params } from '../fn/avatar/update-user-avatar';

@Injectable({ providedIn: 'root' })
export class AvatarService extends BaseServiceUrl {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getCustomerAvatar()` */
  static readonly GetCustomerAvatarPath = '/api/avatar/customer/{customerId}';

  /**
   * Get Customer Avatar.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getCustomerAvatar()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCustomerAvatar$Response(params: GetCustomerAvatar$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return getCustomerAvatar(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Customer Avatar.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getCustomerAvatar$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCustomerAvatar(params: GetCustomerAvatar$Params, context?: HttpContext): Observable<void> {
    return this.getCustomerAvatar$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `updateCustomerAvatar()` */
  static readonly UpdateCustomerAvatarPath = '/api/avatar/customer/{customerId}';

  /**
   * Update Customer Avatar.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateCustomerAvatar()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  updateCustomerAvatar$Response(params: UpdateCustomerAvatar$Params, context?: HttpContext): Observable<StrictHttpResponse<ResultStringDto>> {
    return updateCustomerAvatar(this.http, this.rootUrl, params, context);
  }

  /**
   * Update Customer Avatar.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateCustomerAvatar$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  updateCustomerAvatar(params: UpdateCustomerAvatar$Params, context?: HttpContext): Observable<ResultStringDto> {
    return this.updateCustomerAvatar$Response(params, context).pipe(
      map((r: StrictHttpResponse<ResultStringDto>): ResultStringDto => r.body)
    );
  }

  /** Path part for operation `getCustomerFeedMillAvatar()` */
  static readonly GetCustomerFeedMillAvatarPath = '/api/avatar/customerFeedMill/{customerFeedMillId}';

  /**
   * Get Customer Feed Mill Avatar.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getCustomerFeedMillAvatar()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCustomerFeedMillAvatar$Response(params: GetCustomerFeedMillAvatar$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return getCustomerFeedMillAvatar(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Customer Feed Mill Avatar.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getCustomerFeedMillAvatar$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCustomerFeedMillAvatar(params: GetCustomerFeedMillAvatar$Params, context?: HttpContext): Observable<void> {
    return this.getCustomerFeedMillAvatar$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `updateCustomerFeedMillAvatar()` */
  static readonly UpdateCustomerFeedMillAvatarPath = '/api/avatar/customerFeedMill/{customerFeedMillId}';

  /**
   * Update Customer Feed Mill Avatar.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateCustomerFeedMillAvatar()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  updateCustomerFeedMillAvatar$Response(params: UpdateCustomerFeedMillAvatar$Params, context?: HttpContext): Observable<StrictHttpResponse<ResultStringDto>> {
    return updateCustomerFeedMillAvatar(this.http, this.rootUrl, params, context);
  }

  /**
   * Update Customer Feed Mill Avatar.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateCustomerFeedMillAvatar$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  updateCustomerFeedMillAvatar(params: UpdateCustomerFeedMillAvatar$Params, context?: HttpContext): Observable<ResultStringDto> {
    return this.updateCustomerFeedMillAvatar$Response(params, context).pipe(
      map((r: StrictHttpResponse<ResultStringDto>): ResultStringDto => r.body)
    );
  }

  /** Path part for operation `getCustomerHatcheryAvatar()` */
  static readonly GetCustomerHatcheryAvatarPath = '/api/avatar/customerHatchery/{customerHatcheryId}';

  /**
   * Get Customer Hatchery Avatar.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getCustomerHatcheryAvatar()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCustomerHatcheryAvatar$Response(params: GetCustomerHatcheryAvatar$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return getCustomerHatcheryAvatar(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Customer Hatchery Avatar.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getCustomerHatcheryAvatar$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCustomerHatcheryAvatar(params: GetCustomerHatcheryAvatar$Params, context?: HttpContext): Observable<void> {
    return this.getCustomerHatcheryAvatar$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `updateCustomerHatcheryAvatar()` */
  static readonly UpdateCustomerHatcheryAvatarPath = '/api/avatar/customerHatchery/{customerHatcheryId}';

  /**
   * Update Customer Hatchery Avatar.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateCustomerHatcheryAvatar()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  updateCustomerHatcheryAvatar$Response(params: UpdateCustomerHatcheryAvatar$Params, context?: HttpContext): Observable<StrictHttpResponse<ResultStringDto>> {
    return updateCustomerHatcheryAvatar(this.http, this.rootUrl, params, context);
  }

  /**
   * Update Customer Hatchery Avatar.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateCustomerHatcheryAvatar$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  updateCustomerHatcheryAvatar(params: UpdateCustomerHatcheryAvatar$Params, context?: HttpContext): Observable<ResultStringDto> {
    return this.updateCustomerHatcheryAvatar$Response(params, context).pipe(
      map((r: StrictHttpResponse<ResultStringDto>): ResultStringDto => r.body)
    );
  }

  /** Path part for operation `getUserAvatar()` */
  static readonly GetUserAvatarPath = '/api/avatar/user/{userId}';

  /**
   * Get User Avatar.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getUserAvatar()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUserAvatar$Response(params: GetUserAvatar$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return getUserAvatar(this.http, this.rootUrl, params, context);
  }

  /**
   * Get User Avatar.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getUserAvatar$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUserAvatar(params: GetUserAvatar$Params, context?: HttpContext): Observable<void> {
    return this.getUserAvatar$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `updateUserAvatar()` */
  static readonly UpdateUserAvatarPath = '/api/avatar/user/{userId}';

  /**
   * Update User Avatar.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateUserAvatar()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  updateUserAvatar$Response(params: UpdateUserAvatar$Params, context?: HttpContext): Observable<StrictHttpResponse<ResultStringDto>> {
    return updateUserAvatar(this.http, this.rootUrl, params, context);
  }

  /**
   * Update User Avatar.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateUserAvatar$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  updateUserAvatar(params: UpdateUserAvatar$Params, context?: HttpContext): Observable<ResultStringDto> {
    return this.updateUserAvatar$Response(params, context).pipe(
      map((r: StrictHttpResponse<ResultStringDto>): ResultStringDto => r.body)
    );
  }

}
